<template>
  <div class="product">
    <el-form size="small" :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline">
      <el-form-item label="热搜词汇">
        <el-input size="small" v-model="searchForm.term" placeholder="请输入热搜词汇"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="product-content">
      <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
        <el-table-column prop="term" label="热词" min-width="240px"></el-table-column>
        <el-table-column prop="count" label="搜索次数" align="center" width="100px"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" header-align="center" width="170px"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js'

export default {
  name: 'index',
  data () {
    return {
      /*搜索参数*/
      searchForm: {
        term: ''
      },
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 16,
      /*一共多少条数据*/
      total: 0,
      /*当前是第几页*/
      curPage: 1,
      tableData: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.curPage = 1
      this.getData()
    },
    getData () {
      let self = this
      let params = Object.assign({}, self.searchForm)
      params.pageIndex = self.curPage
      params.pageSize = self.pageSize
      PorductApi.getHotWord(params, true).then(res => {
        self.loading = false
        self.tableData = res.data.records
        self.total = res.data.total
      }).catch(error => {
        self.loading = false
      })
    },
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.loading = true
      self.curPage = val
      self.getData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.pageSize = val
      this.getData()
    },
    onSubmit () {
      this.curPage = 1
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/product/hotword/index.vue